import './Preorders.scss';
import { Button, DataGrid, Form, Tooltip } from 'devextreme-react';
import { Column, Editing, Item, Paging, SearchPanel, Toolbar, Button as Butt, Selection, FilterRow, Pager, Scrolling } from 'devextreme-react/data-grid';
import { AddIcon, filter, CreateOrders, resButtonRefresh, CreateOrdersWhite, errorInvoice, successInvoice, warningInvoice } from '../../images/icons';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { useAppDispatch, useAppSelector } from '../../contexts/hooks';
import { setData, setMode } from '../../contexts/slices/preorders';
import { FormPopup, newToast } from '../../components';
import { Item as ItemF } from 'devextreme-react/form';
import ModalCreatePreOrder from './Modals/ModalCreatePreOrder';
import moment from 'moment';
import { useApiPreorders } from '../../api/api.Preorders';
import ConfirmationPopup from '../../components/utils/popup-confirmation/PopupConfirmation';
import { useApiOrders } from '../../api/api.orders';
import { OrderSummary } from '../../types/types.orders';
import { ModalOrdersSummary } from './Modals/ModalOrdersSummary';
import { ModalCreateAppointment } from '../billing/Quotations/Modals/ModalCreateAppointment';
import { ModalReportPreorden } from '../../components/library/reporting/ModalReportPreorden';
import { useApiBarcodes } from '../../api/api.barcodes';
import { SysI_CodBarrasImpresoras } from '../../types/types.barcodes';
import { setModalBarcodePrintersVisible } from '../../contexts/slices/config';
import { useApiAppointments } from '../../api/api.appoiments';
import { EAFacturarEnableOptions, EFEVRIPSStatus } from '../../types/types.preorders';
import { useScreenSize } from '../../utils/media-query';

const initialFilters = {
  Fechas: [new Date(), new Date()] as [Date | null, Date | null],
  idPreorden: null as number | null,
  lstAgendas: undefined as number[] | undefined,
  Contrato: undefined as number[] | undefined,
  Factura: undefined as boolean | undefined,
  Rips: undefined as boolean | undefined,
};

const facturaFilterOptions = [
  { text: 'Todos', value: null },
  { text: 'Facturados', value: true },
  { text: 'No facturados', value: false },
];

const ripsFilterOptions = [
  { text: 'Todos', value: null },
  { text: 'RIPS generados', value: true },
  { text: 'RIPS no enviados', value: false },
];

type SelectedItem = {
  Usuario?: any;
  [key: string]: any;
};

type FilterSummaryItem = { label: string; tooltip?: string };

const buildFilterSummary = (filters: any, agendas: any[], contratos: any[]): FilterSummaryItem[] => {
  if (!filters) return [];

  const today = moment().format('YYYY-MM-DD');
  const parts: FilterSummaryItem[] = [];

  const [fInicio, fFin] = filters.Fechas || [];
  if (fInicio && fFin) {
    const ini = moment(fInicio).format('YYYY-MM-DD');
    const fin = moment(fFin).format('YYYY-MM-DD');
    if (ini !== today || fin !== today) {
      parts.push({ label: `Fechas: ${moment(fInicio).format('DD/MM/YYYY')} - ${moment(fFin).format('DD/MM/YYYY')}` });
    }
  }

  if (filters.idPreorden) parts.push({ label: `Nro. Preorden: ${filters.idPreorden}` });

  if (filters.lstAgendas?.length) {
    const nombres = filters.lstAgendas.map((id: number) => agendas.find((a) => a.Ag_Id === id)?.Ag_Nombre).filter(Boolean);
    parts.push({ label: `Agendas (${filters.lstAgendas.length})`, tooltip: nombres.join(', ') });
  }

  if (filters.Contrato?.length) {
    const nombres = filters.Contrato.map((id: number) => contratos.find((c) => c.Cn_Id === id)?.Cn_Nombre).filter(Boolean);
    parts.push({ label: `Contratos (${filters.Contrato.length})`, tooltip: nombres.join(', ') });
  }

  if (filters.Factura !== null && filters.Factura !== undefined) {
    parts.push({ label: `Factura: ${facturaFilterOptions.find((o) => o.value === filters.Factura)?.text ?? filters.Factura}` });
  }

  if (filters.Rips !== null && filters.Rips !== undefined) {
    parts.push({ label: `RIPS: ${ripsFilterOptions.find((o) => o.value === filters.Rips)?.text ?? filters.Rips}` });
  }

  return parts;
};

export default () => {
  const gridRef = useRef<DataGrid>(null);
  const dispatch = useAppDispatch();
  const Prm_Citas_C = useAppSelector((state) => state.userInfo.Permissions?.Prm_Citas_C);
  const ModuleBarcode: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleBarcode')[0].Cgn_Resultado) || 'false');
  const ModuleSchedule: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleSchedule')[0].Cgn_Resultado) || 'false');
  const CreateOrderAutomaticInPreorder: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'CreateOrderAutomaticInPreorder')[0].Cgn_Resultado) || 'false');
  const ModuleFEVRIPS: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleFEVRIPS')[0].Cgn_Resultado) || 'false');
  const AFacturarEnableOptionsRaw = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AFacturarEnableOptions')[0])?.Cgn_Resultado;
  const AFacturarEnableOptions: EAFacturarEnableOptions = AFacturarEnableOptionsRaw ? parseInt(AFacturarEnableOptionsRaw) : EAFacturarEnableOptions.FEV;
  const SystemFields = useAppSelector((x) => x.configuration.Data?.SystemFields);
  const Combobox = useAppSelector((x) => x.configuration.Data?.ComboBox);
  const contratoFieldActive = useMemo(() => !!SystemFields?.some((x) => (x.Dfc_Tabla === 'Ordenes' || x.Dfc_Tabla === 'PreOrdenes') && x.Dfc_Equivalencia === 'Ord_Cn_Id' && x.Dfc_Estado === true), [SystemFields]);
  const lstContratos = useMemo(() => {
    const field = SystemFields?.find((x) => (x.Dfc_Tabla === 'Ordenes' || x.Dfc_Tabla === 'PreOrdenes') && x.Dfc_Equivalencia === 'Ord_Cn_Id' && x.Dfc_Estado === true);
    if (!field) return [];
    return Combobox?.find((c) => c.Id === field.Dfc_Tbc_Id)?.Data || [];
  }, [SystemFields, Combobox]);

  const [QuotationData, setQuotationData] = useState<any>(null);
  const [ModalCreateAppointmentVisible, setModalCreateAppointmentVisible] = useState(false);
  const [currentDataDetalle, setCurrentDataDetalle] = useState<any>([]);
  const [modalFiltersVisible, setModalFiltersVisible] = useState(false);
  const [ModalVisible, setModalVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedItems, setSelectedItems] = useState<SelectedItem[]>([]);
  const { GetByFilter, deletePr } = useApiPreorders();
  const { NewOrderFromPreOrders, findOrder } = useApiOrders();
  const [modalConfirmationVisible, setModalConfirmationVisible] = useState(false);
  const [selectedPreordenId, setSelectedPreordenId] = useState<number | null>(null);
  const [visibleReport, setVisibleReport] = useState(false);
  const [dataAgendas, setDataAgendas] = useState<any[]>([]);
  const Prm_CodBarImprimir = useAppSelector((x) => x.userInfo.Permissions?.Prm_CodBarImprimir);
  const { getAgendas } = useApiAppointments();
  const [currentPrinter, setCurrentPrinter] = useState<SysI_CodBarrasImpresoras | undefined>(undefined);
  const { getPrinters } = useApiBarcodes();
  const [orderSummaryState, setOrderSummaryState] = useState({
    visible: false,
    loading: false,
    data: [] as OrderSummary[],
  });
  const [filters] = useState(initialFilters);
  const [visibleRowCount, setVisibleRowCount] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState<any>(null);
  const { isLarge, isMedium } = useScreenSize();

  const filterSummary = useMemo(() => buildFilterSummary(appliedFilters, dataAgendas, lstContratos), [appliedFilters, dataAgendas, lstContratos]);

  // Estados para datos

  useEffect(() => {
    if (CreateOrderAutomaticInPreorder) {
      getPrinterInfo();
    }

    if (ModuleSchedule) {
      getAgendas().then((res) => {
        setDataAgendas(res);
      });
    }
  }, []);

  const getPrinterInfo = async () => {
    if (!ModuleBarcode) {
      return;
    }
    //Verificar si tenemos en localStorage una impresora configurada.
    const printerData = localStorage.getItem('defaultPrinter');
    let printer: SysI_CodBarrasImpresoras | undefined;
    if (printerData) {
      printer = JSON.parse(printerData);
      setCurrentPrinter(printer);
    } else {
      const printers = await getPrinters();
      if (printers?.length === 0) {
      } else if (printers?.length === 1) {
        localStorage.setItem('defaultPrinter', JSON.stringify(printers[0]));
        printer = printers[0];
        setCurrentPrinter(printer);
        newToast('INFO', `Se ha establecido la impresora '${printer.Cbp_Nombre}' como predeterminada.`, 5);
      } else {
        if (Prm_CodBarImprimir) {
          dispatch(setModalBarcodePrintersVisible(true));
        }
      }
    }
  };

  const handleNewClick = useCallback(() => {
    dispatch(setMode({ mode: 'new' }));
    setCurrentDataDetalle(null);
    setModalVisible(true);
  }, [setModalVisible]);

  const fetchData = useCallback(async () => {
    gridRef.current?.instance?.beginCustomLoading('');
    const [start, end] = filters.Fechas || [null, null];
    const payload = {
      ...filters,
      startDate: start ? moment(start).format('YYYY-MM-DD') : '',
      endDate: end ? moment(end).format('YYYY-MM-DD') : '',
    };

    delete (payload as any).Fechas;
    const result = await GetByFilter(payload);
    gridRef.current?.instance?.endCustomLoading();

    setDataSource(result);
    setAppliedFilters(JSON.parse(JSON.stringify(filters)));
  }, [filters, GetByFilter]);

  const handleUpdateData = useCallback(() => {
    // Primero ejecutar la búsqueda, luego cerrar el modal
    fetchData();
    setModalFiltersVisible(false);
  }, [fetchData]);

  // useEffect(() => {
  //   fetchData();
  // }, [filters.startDate, filters.endDate, fetchData]);

  const handleModalShowFilter = useCallback(() => {
    setModalFiltersVisible(!modalFiltersVisible);
  }, [modalFiltersVisible]);

  const customDataSrc = useMemo(() => {
    return new CustomStore({
      key: 'POrd_Id',
      load: () =>
        Promise.resolve({
          data: dataSource,
          totalCount: dataSource.length,
        }),
      remove: (key) => {
        return deletePr(key).then((res) => {
          if (res) {
            fetchData();
          }
        });
      },
    });
  }, [dataSource]);

  const customData = useMemo(() => {
    return new DataSource({
      store: customDataSrc,
      reshapeOnPush: true,
    });
  }, [customDataSrc]);

  const handleView = useCallback(
    (e) => {
      dispatch(setData(e.row.data));
      setCurrentDataDetalle(e.row.data);
      setModalVisible(true);
    },
    [setModalVisible, dispatch]
  );

  const handleClose = useCallback(
    (update: boolean) => {
      if (update) {
        fetchData();
      }
      setModalVisible(false);
    },
    [setModalVisible]
  );

  const handleSelectItems = useCallback(
    (e) => {
      setSelectedItems(e.selectedRowsData);
    },
    [setSelectedItems]
  );

  const handleClicCreateOrders = useCallback(() => {
    if (selectedItems.length === 0) {
      return;
    }
    setModalConfirmationVisible(true);
  }, [selectedItems]);

  const handleConfirmation = useCallback(async () => {
    setModalConfirmationVisible(false);
    const newItems = selectedItems
      .filter((x) => x.POrd_Ord_Id === null)
      .map((item) => {
        // Ya no necesitamos filtrar Usuario y Paciente porque son campos planos
        const { Us_Id, Us_Usuario, Pc_Id, Pc_Identificacion, Pc_Nombre, Pc_Apellido1, Pc_Apellido2, Estudios, ...rest } = item;
        return rest;
      });

    setOrderSummaryState({
      visible: true,
      loading: true,
      data: [],
    });

    const SendData = {
      PreOrders: newItems,
      IdPrinter: currentPrinter?.Cbp_Id,
    };

    NewOrderFromPreOrders(SendData).then((res) => {
      if (res) {
        setOrderSummaryState({
          visible: true,
          loading: false,
          data: res,
        });
      } else {
        setOrderSummaryState({
          visible: true,
          loading: false,
          data: [],
        });
      }
    });
  }, [selectedItems, NewOrderFromPreOrders, setOrderSummaryState]);

  useEffect(() => {
    if (!orderSummaryState.visible) {
      // Reset the selected items when the order summary modal is closed
      gridRef.current?.instance.clearSelection();
      setSelectedItems([]);
      //Actualizamos el grid
      fetchData();
    }
  }, [orderSummaryState.visible]);

  const handleCancelConfirmation = useCallback(() => {
    setModalConfirmationVisible(false);
    gridRef.current?.instance.clearSelection();
  }, []);

  const setLoading = () => {};

  const handleFindOrder = useCallback(
    (e) => {
      if (!e) {
        newToast('WARNING', 'No hay una orden asociada', 5);
        return;
      }
      findOrder(undefined, e, setLoading, true);
    },
    [findOrder]
  );

  const handleCloseModal = useCallback(() => {
    setOrderSummaryState({ ...orderSummaryState, visible: false });
    fetchData();
  }, [setModalVisible]);

  const handleClicCreateAppointment = useCallback(
    (e) => {
      if (!Prm_Citas_C) {
        newToast('WARNING', 'No tienes permisos para crear citas', 3);
        return;
      }
      setQuotationData(e.row.data);
      setModalCreateAppointmentVisible(true);
    },
    [setModalCreateAppointmentVisible]
  );

  const handleClicPrint = useCallback((e) => {
    const preordenId = e.row.data.POrd_Id;
    // Validar que el ID sea válido
    if (!preordenId) {
      newToast('ERROR', 'No se puede imprimir este recibo', 4);
      return;
    }

    // Solo establecer el ID, NO sobrescribir dataSource
    setSelectedPreordenId(preordenId);
    setVisibleReport(true);
  }, []);

  // También actualiza el handleCloseModalPrint para limpiar el ID
  const handleCloseModalPrint = useCallback(() => {
    setVisibleReport(false);
    setSelectedPreordenId(null); // ✅ Limpiar el ID al cerrar
  }, []);

  // Handler para actualizar el conteo total de filas (no solo la página actual)
  const handleContentReady = useCallback((e: any) => {
    const count = e.component.totalCount();
    setVisibleRowCount(count < 0 ? 0 : count);
  }, []);

  // Componente para renderizar el estado FEV/RIPS en la columna NRO
  const renderFEVRIPSStatus = useCallback(
    (cellData: any) => {
      const { POrd_Id, POrd_FEV_Estado, POrd_RIPS_Estado } = cellData.data;

      // Si el módulo no está habilitado, solo mostrar el número
      if (!ModuleFEVRIPS) {
        return <span>{POrd_Id}</span>;
      }

      // Determinar el estado del icono
      let statusIcon: string | null = null;
      let tooltipText = '';

      if (AFacturarEnableOptions === EAFacturarEnableOptions.FEV) {
        // Solo verificar FEV
        if (POrd_FEV_Estado === EFEVRIPSStatus.Success) {
          statusIcon = successInvoice;
          tooltipText = 'FEV: Exitoso';
        } else if (POrd_FEV_Estado === EFEVRIPSStatus.Error) {
          statusIcon = errorInvoice;
          tooltipText = 'FEV: Error';
        } else if (POrd_FEV_Estado === EFEVRIPSStatus.Pending || POrd_FEV_Estado === EFEVRIPSStatus.Sending) {
          statusIcon = warningInvoice;
          tooltipText = 'FEV: Pendiente';
        }
      } else if (AFacturarEnableOptions === EAFacturarEnableOptions.FEV_RIPS) {
        // Verificar ambos FEV y RIPS
        const fevOk = POrd_FEV_Estado === EFEVRIPSStatus.Success;
        const ripsOk = POrd_RIPS_Estado === EFEVRIPSStatus.Success;
        const fevError = POrd_FEV_Estado === EFEVRIPSStatus.Error;
        const ripsError = POrd_RIPS_Estado === EFEVRIPSStatus.Error;

        if (fevOk && ripsOk) {
          statusIcon = successInvoice;
          tooltipText = 'FEV y RIPS: Exitoso';
        } else if (fevError || ripsError) {
          statusIcon = errorInvoice;
          tooltipText = `${fevError ? 'FEV: Error' : 'FEV: OK'} | ${ripsError ? 'RIPS: Error' : ripsOk ? 'RIPS: OK' : 'RIPS: Pendiente'}`;
        } else if (POrd_FEV_Estado || POrd_RIPS_Estado) {
          statusIcon = warningInvoice;
          tooltipText = `FEV: ${fevOk ? 'OK' : 'Pendiente'} | RIPS: ${ripsOk ? 'OK' : 'Pendiente'}`;
        }
      }

      return (
        <div className='fevrips-status-cell'>
          <span className='preorder-number'>{POrd_Id}</span>
          {statusIcon && (
            <>
              <img id={`fev-status-${POrd_Id}`} src={statusIcon} alt='Estado' className='fevrips-status-icon' />
              <Tooltip target={`#fev-status-${POrd_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                {tooltipText}
              </Tooltip>
            </>
          )}
        </div>
      );
    },
    [ModuleFEVRIPS, AFacturarEnableOptions]
  );

  return (
    <div className={'view crm-contact-list'}>
      <div className={'view-wrapper view-wrapper-contact-list'}>
        <DataGrid className='grid' dataSource={customData} ref={gridRef} height='100%' width={'100%'} hoverStateEnabled={true} repaintChangesOnly={true} onSelectionChanged={handleSelectItems} onContentReady={handleContentReady} highlightChanges={false} rowAlternationEnabled={true} showColumnLines={true} columnAutoWidth={false} showBorders={true}>
          <Scrolling mode='standard' columnRenderingMode='virtual' showScrollbar='onHover' />
          <Editing allowUpdating={true} allowDeleting={true} />
          <FilterRow visible={true} applyFilter='auto' />
          <SearchPanel visible placeholder='Buscar' />
          <Selection mode='multiple' />
          <Paging enabled={true} />
          <Pager visible={true} allowedPageSizes={[20, 50, 100, 'all']} displayMode='full' showPageSizeSelector={true} showInfo={true} showNavigationButtons={true} />
          <Toolbar>
            <Item location='before' visible={isLarge || isMedium}>
              <div className='grid-header'>
                Preórdenes <span className='record-count'>{visibleRowCount} registros</span>
                {filterSummary.length > 0 && (
                  <span className='filter-summary'>
                    |{' '}
                    {filterSummary.map((item, index) => {
                      const id = `filter-chip-${index}`;
                      return (
                        <span key={id}>
                          {index > 0 && ' · '}
                          <span id={id} className={item.tooltip ? 'filter-chip-tip' : ''}>
                            {item.label}
                          </span>
                          {item.tooltip && (
                            <Tooltip target={`#${id}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                              {item.tooltip}
                            </Tooltip>
                          )}
                        </span>
                      );
                    })}
                  </span>
                )}
              </div>
            </Item>
            <Item location='after' visible={selectedItems.length > 0} locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='#toolBarNewOrd' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Crear órdenes seleccionadas
              </Tooltip>
              <Button id='toolBarNewOrd' text={'Nuevo'} stylingMode='outlined' icon={CreateOrders} type='success' onClick={handleClicCreateOrders} />
            </Item>
            <Item location='after' visible={selectedItems.length > 0} locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='#toolBarNew' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Nueva preorden
              </Tooltip>
              <Button id='toolBarNew' text={'Nuevo'} stylingMode='outlined' icon={AddIcon} type='success' onClick={handleNewClick} />
            </Item>
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='.filter-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Filtrar preórdenes
              </Tooltip>
              <Button className='filter-button' icon={filter} text='Filtrar' stylingMode='text' onClick={handleModalShowFilter} />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='.refresh-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Refrescar datos
              </Tooltip>
              <Button className='refresh-button' icon={resButtonRefresh} text='Actualizar' stylingMode='text' onClick={handleUpdateData} />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>
          <Column dataField='POrd_Id' caption='NRO.' alignment='center' width={ModuleFEVRIPS ? 80 : 65} cellRender={renderFEVRIPSStatus} />
          <Column
            dataField='POrd_Ord_Id'
            caption='ORD.'
            width={60}
            alignment='center'
            cellRender={({ data }: { data: any }) => {
              const orderId = data.POrd_Id;
              return (
                <div id={`ord${orderId}`}>
                  <img
                    src={data.POrd_Ord_Id ? CreateOrders : CreateOrdersWhite}
                    alt='Orden'
                    onClick={() => {
                      handleFindOrder(data.POrd_Ord_Id);
                    }}
                  />
                  <Tooltip target={`#ord${orderId}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                    {data.POrd_Ord_Id ? `Ver orden` : 'No hay orden asociada'}
                  </Tooltip>
                </div>
              );
            }}
          />

          <Column dataField='POrd_FechaCreacion' caption='FECHA' dataType='datetime' format='dd/MM/yyyy' alignment='left' width={95} />
          <Column dataField='Pc_Identificacion' caption='DOCUMENTO' alignment='center' width={110} />
          <Column
            dataField='Paciente'
            cellRender={handlePatientCellRender}
            calculateCellValue={(rowData) => {
              const { Pc_Nombre, Pc_Apellido1, Pc_Apellido2 } = rowData;
              return `${Pc_Nombre} ${Pc_Apellido1 || ''} ${Pc_Apellido2 || ''}`.trim();
            }}
            minWidth={150}
            caption='PACIENTE'
            alignment='left'
          />
          {contratoFieldActive && (
            <Column
              dataField='POrd_Cn_Id'
              caption='CONTRATO'
              alignment='left'
              width={150}
              calculateCellValue={(rowData: any) => {
                const id = rowData.POrd_Cn_Id;
                if (!id) return '';
                return lstContratos.find((c: any) => c.Cn_Id === id)?.Cn_Nombre || '';
              }}
            />
          )}
          <Column dataField='Us_Usuario' caption='CREADO POR' alignment='center' width={140} />
          <Column dataField='Estudios' caption='EXÁMENES' alignment='left' minWidth={220} />

          <Column type='buttons' caption={'ACCIÓN'} width={120}>
            <Butt icon='eyeopen' text='Ver' onClick={handleView} />
            <Butt icon='custom-date' text='Crear cita' onClick={handleClicCreateAppointment} />
            <Butt icon='print' text='Imprimir' hint='Imprimir recibo' onClick={handleClicPrint} />
            <Butt name='delete' text='Eliminar' />
          </Column>
        </DataGrid>
      </div>
      {modalFiltersVisible && (
        <FormPopup title='Filtrar preórdenes' visible={modalFiltersVisible} setVisible={handleModalShowFilter} onSave={handleUpdateData} loading={false} allowSave={false}>
          <Form formData={filters} labelLocation='left' className='plain-styled-form' onEditorEnterKey={handleUpdateData}>
            <ItemF
              dataField='idPreorden'
              editorType='dxNumberBox'
              label={{ text: 'Nro. Preorden' }}
              editorOptions={{
                showClearButton: true,
                placeholder: 'Buscar por número',
              }}
            />
            <ItemF
              dataField='Fechas'
              editorType='dxDateRangeBox'
              label={{ text: 'Rango de fechas' }}
              editorOptions={{
                displayFormat: 'shortdate',
                acceptCustomValue: false,
                showClearButton: true,
              }}
            />
            {ModuleSchedule && (
              <ItemF
                dataField='lstAgendas'
                editorType='dxTagBox'
                label={{ text: 'Agenda asignada a' }}
                editorOptions={{
                  dataSource: dataAgendas,
                  displayExpr: 'Ag_Nombre',
                  valueExpr: 'Ag_Id',
                  showSelectionControls: true,
                  showClearButton: true,
                  placeholder: 'Seleccione una o varias agendas',
                  maxDisplayedTags: 1,
                  applyValueMode: 'useButtons',
                  searchEnabled: true,
                }}
              />
            )}
            {contratoFieldActive && (
              <ItemF
                dataField='Contrato'
                editorType='dxTagBox'
                label={{ text: 'Contrato' }}
                editorOptions={{
                  dataSource: lstContratos,
                  displayExpr: 'Cn_Nombre',
                  valueExpr: 'Cn_Id',
                  showSelectionControls: true,
                  showClearButton: true,
                  placeholder: 'Seleccione uno o varios contratos',
                  maxDisplayedTags: 1,
                  applyValueMode: 'useButtons',
                  searchEnabled: true,
                }}
              />
            )}
            {ModuleFEVRIPS && (
              <ItemF
                dataField='Factura'
                editorType='dxSelectBox'
                label={{ text: 'Factura' }}
                editorOptions={{
                  items: facturaFilterOptions,
                  displayExpr: 'text',
                  valueExpr: 'value',
                  showClearButton: true,
                  placeholder: 'Todos',
                }}
              />
            )}
            {ModuleFEVRIPS && AFacturarEnableOptions === EAFacturarEnableOptions.FEV_RIPS && (
              <ItemF
                dataField='Rips'
                editorType='dxSelectBox'
                label={{ text: 'RIPS' }}
                editorOptions={{
                  items: ripsFilterOptions,
                  displayExpr: 'text',
                  valueExpr: 'value',
                  showClearButton: true,
                  placeholder: 'Todos',
                }}
              />
            )}
          </Form>
        </FormPopup>
      )}
      {ModalCreateAppointmentVisible && <ModalCreateAppointment visible={ModalCreateAppointmentVisible} setVisible={setModalCreateAppointmentVisible} quotationId={QuotationData ? QuotationData.Cz_Id : -1} patientDocument={QuotationData ? QuotationData.Pc_Identificacion : ''} patientId={QuotationData ? QuotationData.Pc_Id : -1} preorderId={QuotationData ? QuotationData.POrd_Id : -1} />}
      <ModalReportPreorden visible={visibleReport} setVisible={handleCloseModalPrint} reportName='Preordenes' idPreorden={selectedPreordenId ? selectedPreordenId : -1} />
      {ModalVisible && <ModalCreatePreOrder visible={ModalVisible} setVisible={handleClose} currentData={currentDataDetalle} idPreOrder={currentDataDetalle ? currentDataDetalle.POrd_Id : -1} />}
      {modalConfirmationVisible && <ConfirmationPopup visible={modalConfirmationVisible} onConfirm={handleConfirmation} onCancel={handleCancelConfirmation} message={`Se crearán ${selectedItems.filter((x) => x.POrd_Ord_Id === null).length} órdenes, desea continuar`} />}
      {orderSummaryState.visible && <ModalOrdersSummary visible={orderSummaryState.visible} loading={orderSummaryState.loading} data={orderSummaryState.data} onClose={handleCloseModal} />}
    </div>
  );
};

const handlePatientCellRender = (data: any) => {
  const { Pc_Nombre, Pc_Apellido1, Pc_Apellido2 } = data.data;
  return (
    <div>
      {Pc_Nombre} {Pc_Apellido1 || ''} {Pc_Apellido2 || ''}
    </div>
  );
};
